import { routes } from '../site';

/** 404 sayfasının metni (`pages/NotFound.tsx`); arama/paylaşım etiketi `content/seo.ts → notFoundSeo`. */
export const notFoundPage = {
  code: '404',
  eyebrow: 'Sayfa bulunamadı',
  title: 'Aradığınız sayfa burada değil.',
  description:
    'Adres değişmiş, sayfa taşınmış ya da bağlantı yanlış yazılmış olabilir. Ana sayfadan devam edebilir ya da aşağıdaki sayfalardan birine geçebilirsiniz.',
  /** İstenen adres rozeti; adres tarayıcıda bağlandıktan sonra dolar. */
  pathLabel: 'İstenen adres',
  primary: { label: 'Ana sayfaya dön', href: '/' },
  secondary: { label: 'Bize yaz', href: routes.iletisim },
  suggestionsTitle: 'Sık ziyaret edilen sayfalar',
  suggestions: [
    { label: 'Fiyatlar', desc: 'Paketler ve modüller', href: routes.fiyatlar },
    { label: 'Entegrasyonlar', desc: 'Birlikte çalıştığımız sistemler', href: routes.entegrasyonlar },
    { label: 'Blog', desc: 'Kârlı büyüme için yazılar', href: routes.blog },
    { label: 'SSS', desc: 'Sık sorulan sorular', href: routes.sss },
  ],
} as const;
